__turbopack_context__.v({
  "body": "WalletHistoryItem-module__OTvMRq__body",
  "confirmed": "WalletHistoryItem-module__OTvMRq__confirmed",
  "pending": "WalletHistoryItem-module__OTvMRq__pending",
  "root": "WalletHistoryItem-module__OTvMRq__root",
  "status": "WalletHistoryItem-module__OTvMRq__status",
  "timestamp": "WalletHistoryItem-module__OTvMRq__timestamp",
  "title": "WalletHistoryItem-module__OTvMRq__title",
  "transaction": "WalletHistoryItem-module__OTvMRq__transaction",
  "womp": "WalletHistoryItem-module__OTvMRq__womp",
});
